import { useState } from 'react';
import { connect } from 'react-redux';
import { observer } from 'mobx-react';

import { Table } from '@devexpress/dx-react-grid-bootstrap4';
import { DataTable } from '../core/components/datatable';
import * as actions from './store/actions';
import { useComponentDidMount } from '../core/hooks';
import CarmenUserSelect from './CarmenUserSelect';
import { userActions, userStore } from '../users/store/userStore';

// interface CarmenUsersProps {
//   carmenUsers?: unknown[]
//   getCarmenUsers?(...args: unknown[]): unknown
// }

const CarmenUsers = props => {
  const {
    carmenUsers,
    getCarmenUsers,
  } = props;

  // все пользователи (запрос без partnerId — ключ кэша 'all'); бывш. Redux users.listOfAll
  const users = userStore.usersByPartnerId.all ?? [];

  const columns = [
    { name: 'carmenFio', title: 'ФИО Кармен', width: 350 },
    { name: 'depart', title: 'Отдел', width: 180 },
    { name: 'email', title: 'Email', width: 180 },
    { name: 'phoneNumber', title: 'Телефон', width: 180 },
    { name: 'position', title: 'Позиция', width: 180 },
    {
      name: 'userId',
      title: 'Пользователь Avtoapp',
      width: 400,
      getCellValue: row => <CarmenUserSelect carmenUser={ row } users={ users } />,
    },
  ];

  const [loading, setLoading] = useState(false);

  const loadData = async () => {
    setLoading(true);
    await getCarmenUsers();
    await userActions.getUsers();
    setLoading(false);
  };

  useComponentDidMount(() => {
    loadData();
  });

  return (
    <DataTable
      header='Сотрудники Carmen'
      columns={ columns }
      data={ carmenUsers }
      loading={ loading }
      columnsResizingMode='nextColumn'
      dataCellComponent={ (cellProps) => {
        if (cellProps.column.name === 'userId') {
          return <Table.Cell { ...cellProps } className='overflow-visible' />;
        }
        return <Table.Cell { ...cellProps } />;
      } }
      localPaging
      localSorting
      hideToolbar
    />
  );
};

const mapStateToProps = state => ({
  carmenUsers: state.carmen.carmenUsers,
});
const mapDispatchToProps = dispatch => ({
  getCarmenUsers: payload => dispatch(actions.getCarmenUsers(payload)),
});

// observer — только внутренним слоем: connect возвращает memo-компонент, а observer
// из mobx-react-lite падает при оборачивании memo (см. CarmenUsers/OrderCommentForm и др.)
export default connect(mapStateToProps, mapDispatchToProps)(observer(CarmenUsers));
